import clsx from "clsx";
import { BackgroundTaskStatus } from "./_types";

const STATUS_CLASSES: Record<BackgroundTaskStatus, string> = {
    pending:
        "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300",
    running: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300",
    completed:
        "bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-300",
    failed: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300",
    retrying:
        "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300",
    revoked:
        "bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300",
    lost: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300",
};

export function StatusBadge({ status }: { status: BackgroundTaskStatus }) {
    return (
        <span
            className={clsx(
                "rounded px-1.5 py-0.5 text-xs font-medium capitalize",
                STATUS_CLASSES[status],
            )}
        >
            {status}
        </span>
    );
}

export function formatSeconds(seconds: number | null): string {
    if (seconds === null) return "—";
    if (seconds < 60) return `${seconds.toFixed(1)}s`;
    if (seconds < 3600) return `${(seconds / 60).toFixed(1)}m`;
    return `${(seconds / 3600).toFixed(1)}h`;
}

export function formatDate(date: string | null): string {
    return date ? new Date(date).toLocaleString() : "—";
}

/** "apps.village.tasks.award_vp_bux_task" reads better as "award_vp_bux_task". */
export function shortName(name: string): string {
    return name.split(".").pop() ?? name;
}
